import React from "react";
import { Icon } from "../components/Icon";
import { FinderFilterType } from "../types";
import styles from "./Header.module.css";
import { Loader } from "./Loader";

export type HeaderProps = {
  totalResults: number;
  loading: boolean;
  filters: FinderFilterType[];
  onClearFilter: ({ key, value }: { key: string; value: string }) => void;
  onClearAllFilters: () => void;
};

export const HeaderComponent = ({
  totalResults,
  loading,
  filters,
  onClearFilter,
  onClearAllFilters,
}: HeaderProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {loading ? (
          " "
        ) : (
          <>
            <Message totalResults={totalResults} />
            <ActiveFilters
              filters={filters}
              onClearFilter={onClearFilter}
              onClearAllFilters={onClearAllFilters}
            />
          </>
        )}
      </div>
      <Loader loading={loading} />
    </div>
  );
};

export const Header = React.memo(HeaderComponent);

const Message = ({ totalResults }: { totalResults: number }) => {
  switch (totalResults) {
    case 1:
      return (
        <div className={styles.message}>
          Er is&#32;<strong>1 opleiding</strong>&#32;gevonden
        </div>
      );
    case 0:
      return (
        <div className={styles.message}>Er zijn geen opleidingen gevonden</div>
      );
    default:
      return (
        <div className={styles.message}>
          Er zijn&#32;<strong>{totalResults} opleidingen</strong>&#32;gevonden
        </div>
      );
  }
};

type ActiveFiltersType = {
  label: string;
  value: string;
  key: string;
};

type ActiveFiltersProps = {
  filters: FinderFilterType[];
  onClearFilter: ({ key, value }: { key: string; value: string }) => void;
  onClearAllFilters: () => void;
};

const ActiveFilters = ({
  filters,
  onClearFilter,
  onClearAllFilters,
}: ActiveFiltersProps) => {
  const newFilters = JSON.parse(JSON.stringify([...filters]));
  let activeFilters: ActiveFiltersType[] = newFilters
    .reduce(
      (prev: ActiveFiltersType[], curr: FinderFilterType) => [
        ...prev,
        ...curr.options
          .filter(({ checked }) => checked)
          .map(({ label, value }) => ({
            label,
            value,
            key: curr.key,
          })),
      ],
      []
    )
    .flat();

  if (!activeFilters.length) return null;

  return (
    <>
      <ul className={styles.activeFilters}>
        <li>in</li>
        {activeFilters.map(({ label, value, key }) => (
          <li key={value}>
            <strong>{label}</strong>
            <button
              type="button"
              className={styles.clearActiveFilterButton}
              onClick={() => onClearFilter({ key, value })}
            >
              <Icon icon="clear" />
            </button>
          </li>
        ))}
      </ul>
      {activeFilters.length > 1 && (
        <button
          type="button"
          className={styles.clearAllFiltersButton}
          onClick={onClearAllFilters}
        >
          Wis alle filters <Icon icon="clear" />
        </button>
      )}
    </>
  );
};
